export type USState = {
  stateCode: string;
  name: string;
};

export const US_STATES: USState[] = [
  { stateCode: "AL", name: "Alabama" },
  { stateCode: "AK", name: "Alaska" },
  { stateCode: "AZ", name: "Arizona" },
  { stateCode: "AR", name: "Arkansas" },
  { stateCode: "CA", name: "California" },
  { stateCode: "CO", name: "Colorado" },
  { stateCode: "CT", name: "Connecticut" },
  { stateCode: "DE", name: "Delaware" },
  { stateCode: "DC", name: "District of Columbia" },
  { stateCode: "FL", name: "Florida" },
  { stateCode: "GA", name: "Georgia" },
  { stateCode: "HI", name: "Hawaii" },
  { stateCode: "ID", name: "Idaho" },
  { stateCode: "IL", name: "Illinois" },
  { stateCode: "IN", name: "Indiana" },
  { stateCode: "IA", name: "Iowa" },
  { stateCode: "KS", name: "Kansas" },
  { stateCode: "KY", name: "Kentucky" },
  { stateCode: "LA", name: "Louisiana" },
  { stateCode: "ME", name: "Maine" },
  { stateCode: "MD", name: "Maryland" },
  { stateCode: "MA", name: "Massachusetts" },
  { stateCode: "MI", name: "Michigan" },
  { stateCode: "MN", name: "Minnesota" },
  { stateCode: "MS", name: "Mississippi" },
  { stateCode: "MO", name: "Missouri" },
  { stateCode: "MT", name: "Montana" },
  { stateCode: "NE", name: "Nebraska" },
  { stateCode: "NV", name: "Nevada" },
  { stateCode: "NH", name: "New Hampshire" },
  { stateCode: "NJ", name: "New Jersey" },
  { stateCode: "NM", name: "New Mexico" },
  { stateCode: "NY", name: "New York" },
  { stateCode: "NC", name: "North Carolina" },
  { stateCode: "ND", name: "North Dakota" },
  { stateCode: "OH", name: "Ohio" },
  { stateCode: "OK", name: "Oklahoma" },
  { stateCode: "OR", name: "Oregon" },
  { stateCode: "PA", name: "Pennsylvania" },
  { stateCode: "RI", name: "Rhode Island" },
  { stateCode: "SC", name: "South Carolina" },
  { stateCode: "SD", name: "South Dakota" },
  { stateCode: "TN", name: "Tennessee" },
  { stateCode: "TX", name: "Texas" },
  { stateCode: "UT", name: "Utah" },
  { stateCode: "VT", name: "Vermont" },
  { stateCode: "VA", name: "Virginia" },
  { stateCode: "WA", name: "Washington" },
  { stateCode: "WV", name: "West Virginia" },
  { stateCode: "WI", name: "Wisconsin" },
  { stateCode: "WY", name: "Wyoming" },
];

export const US_STATE_SELECT_OPTIONS = US_STATES.map((s) => ({
  value: s.stateCode,
  label: s.name,
}));
